<div class="login-container">
  <div class="login-wrapper">
    <div class="login-card">
      <div class="login-brand">
        <div class="logo-icon">
          <i class="bi bi-box-seam"></i>
        </div>
        <div class="brand-text">
          <h1>I<span>MS</span></h1>
          <p>Inventory Management System</p>
        </div>
      </div>

      @if (!submitted) {
        <div class="login-welcome">
          <h2>Reset Password</h2>
          <p>Create a new password for {{ email || 'your account' }}</p>
        </div>

        <form class="login-form" (ngSubmit)="resetPassword()">
          <div class="form-group">
            <label for="resetOtp">Reset OTP</label>
            <div class="input-wrapper">
              <i class="bi bi-shield-check"></i>
              <input
                type="text"
                inputmode="numeric"
                id="resetOtp"
                name="resetOtp"
                [(ngModel)]="resetOtp"
                placeholder="Enter OTP from email"
                required
                maxlength="6"
                appDigitsOnly
                [appMaxDigits]="6"
              />
            </div>
            @if (devOtpHint) {
              <small class="dev-otp-hint">Dev OTP: {{ devOtpHint }}</small>
            }
          </div>

          <div class="form-group">
            <label for="password">New Password</label>
            <div class="input-wrapper">
              <i class="bi bi-lock"></i>
              <input
                [type]="showPassword ? 'text' : 'password'"
                id="password"
                name="password"
                [(ngModel)]="password"
                placeholder="Enter new password"
                required
              />
              <button type="button" class="toggle-password" (click)="togglePassword()">
                <i class="bi" [class.bi-eye]="!showPassword" [class.bi-eye-slash]="showPassword"></i>
              </button>
            </div>
          </div>

          <div class="form-group">
            <label for="confirmPassword">Confirm Password</label>
            <div class="input-wrapper">
              <i class="bi bi-shield-lock"></i>
              <input
                [type]="showConfirmPassword ? 'text' : 'password'"
                id="confirmPassword"
                name="confirmPassword"
                [(ngModel)]="confirmPassword"
                placeholder="Confirm new password"
                required
              />
              <button type="button" class="toggle-password" (click)="toggleConfirmPassword()">
                <i class="bi" [class.bi-eye]="!showConfirmPassword" [class.bi-eye-slash]="showConfirmPassword"></i>
              </button>
            </div>
          </div>

          @if (errorMessage) {
            <div class="error-message show">
              <i class="bi bi-exclamation-circle"></i>
              <span>{{ errorMessage }}</span>
            </div>
          }

          <button type="submit" class="btn-login" [disabled]="isSubmitting">
            <i class="bi bi-check-lg"></i>
            {{ isSubmitting ? 'Saving password...' : 'Reset Password' }}
          </button>
        </form>

        <button type="button" class="back-to-login" (click)="backToLogin()">
          <i class="bi bi-arrow-left"></i>
          Back to Sign In
        </button>
      } @else {
        <div class="reset-success">
          <div class="success-icon">
            <i class="bi bi-check-circle-fill"></i>
          </div>
          <h2>Password Reset</h2>
          <p>Your password has been updated. You can now sign in with your new password.</p>
          <button type="button" class="btn-login" (click)="backToLogin()">
            <i class="bi bi-box-arrow-in-right"></i>
            Back to Sign In
          </button>
        </div>
      }

      <div class="login-footer">
        <p>&copy; 2026 IMS. All rights reserved.</p>
      </div>
    </div>

    <div class="login-banner">
      <div class="banner-content">
        <div class="banner-icon">
          <i class="bi bi-key"></i>
        </div>
        <h2>Create a Strong<br />New Password</h2>
        <p>Use a secure password to help protect your inventory and equipment data.</p>
        <div class="banner-features">
          <div class="feature">
            <i class="bi bi-check-circle-fill"></i>
            <span>Minimum 6 characters</span>
          </div>
          <div class="feature">
            <i class="bi bi-check-circle-fill"></i>
            <span>Password confirmation</span>
          </div>
          <div class="feature">
            <i class="bi bi-check-circle-fill"></i>
            <span>Secure account recovery</span>
          </div>
        </div>
      </div>
      <div class="banner-footer">
        <span>Secure &bull; Reliable &bull; Professional</span>
      </div>
    </div>
  </div>
</div>
